import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT = {
  title: "iCaard · One Card, One System, Unlimited Access",
  description: "iCaard is Ghana's all in one digital identity card and wallet. pay with QR, buy event tickets, ride iTravellers transport, manage schools, hostels and more.",
};

// Exact-path (or longest-prefix) route metadata — every public page gets a
// unique title + description for SEO.
const ROUTES = {
  "/login": {
    title: "Choose Your Portal · iCaard Ghana",
    description: "Pick your iCaard portal. customer, student, merchant, food vendor, event organizer, hostel owner, service provider, iPrint shop or Area Coordinator. and sign in.",
  },
  "/landing": {
    title: "iCaard. Ghana's Digital ID, Wallet & Ticketing Card",
    description: "Discover iCaard: a smart QR card that carries your identity, wallet, tickets and loyalty across Ghana. Cashless payments, events, transport and school management in one card.",
  },
  "/auth": {
    title: "Sign In or Activate Your iCaard · iCaard Ghana",
    description: "Log in to your iCaard account or activate a newly purchased physical iCaard to unlock your wallet, tickets and digital identity.",
  },
  "/auth/pin": {
    title: "Partner PIN Login · iCaard Ghana",
    description: "Fast PIN sign in for iCaard partners. merchants, organizers, vendors, transport companies, schools and service providers.",
  },
  "/coordinator/register": {
    title: "Become an Area Coordinator · iCaard Ghana",
    description: "Complete your Area Coordinator application: sell and replace iCaard physical cards in your area, manage merchants and earn instant commissions.",
  },
  "/coordinator": {
    title: "Area Coordinator Portal · iCaard Ghana",
    description: "Sign in to the iCaard Area Coordinator portal to manage your users, card stock, merchant tasks and commissions.",
  },
  "/card": {
    title: "Activate Your Physical iCaard · iCaard Ghana",
    description: "Scan or enter your purchase code to permanently link your new physical iCaard to your account in under a minute.",
  },
  "/customer": {
    title: "Customer Portal · iCaard Ghana",
    description: "The iCaard customer portal. top up your wallet, pay with QR, buy event and transport tickets, and earn loyalty rewards across Ghana.",
  },
  "/student": {
    title: "Student Portal · iCaard Ghana",
    description: "iCaard for students. campus identity, cashless payments, hostel bookings and event tickets on one smart card.",
  },
  "/merchant": {
    title: "Merchant Portal · iCaard Ghana",
    description: "Sell and activate iCaard cards, recharge customer wallets and earn commissions with the iCaard merchant portal.",
  },
  "/organizer": {
    title: "Event Organizer Portal · iCaard Ghana",
    description: "Create events, sell QR tickets, scan check ins and request payouts with iCaard's event organizer tools.",
  },
  "/food": {
    title: "Food Vendor Portal · iCaard Ghana",
    description: "Run your food business on iCaard. menus, QR ordering, wallet payments and instant settlement for vendors in Ghana.",
  },
  "/hostel": {
    title: "Hostel Owner Portal · iCaard Ghana",
    description: "List rooms, manage bookings and collect wallet payments with the iCaard hostel owner portal.",
  },
  "/service": {
    title: "Service Provider Portal · iCaard Ghana",
    description: "Offer professional services, manage your queue and get paid through the iCaard service provider portal.",
  },
  "/iprint": {
    title: "iPrint Shop Portal · iCaard Ghana",
    description: "Receive print jobs, manage orders and collect wallet payments with the iCaard iPrint shop portal.",
  },
  "/transport-board": {
    title: "Live Terminal Board · iTravellers by iCaard",
    description: "Live departures, routes and fares from iTravellers transport companies across Ghana.",
  },
};

function metaFor(pathname) {
  if (ROUTES[pathname]) return ROUTES[pathname];
  const hit = Object.keys(ROUTES)
    .filter((p) => pathname.startsWith(p + "/") || pathname.startsWith(p + "?"))
    .sort((a, b) => b.length - a.length)[0];
  return hit ? ROUTES[hit] : DEFAULT;
}

export default function SeoManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const m = metaFor(pathname);
    document.title = m.title;
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "description");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", m.description);
    let canon = document.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.setAttribute("rel", "canonical");
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", `https://icaard.com${pathname === "/" ? "" : pathname}`);
  }, [pathname]);
  return null;
}
